(() => {
  const dialog = document.getElementById('FeltwhimsyCustomSizeDialog');
  if (!(dialog instanceof HTMLDialogElement)) return;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-feltwhimsy-customize-size]');
    if (!trigger) return;

    event.preventDefault();
    const stylesheet = document.getElementById('FeltwhimsyCustomSizeStyles');
    if (stylesheet) stylesheet.media = 'all';
    if (!dialog.open) dialog.showModal();
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.querySelectorAll('[data-custom-size-close]').forEach((button) => {
    button.addEventListener('click', () => dialog.close());
  });
})();
